<template>
  <div>
    <div class="text-h5 font-weight-bold text-center mb-4">Historial de Arma</div>

    <v-tabs class="mb-3" v-model="selectedTab" color="secondary">
      <v-tab class="font-weight-bold">Asignaciones</v-tab>
      <v-tab class="font-weight-bold">LOCs</v-tab>
    </v-tabs>

    <v-tabs-items v-model="selectedTab" class="transparent">
      <v-tab-item key="1" eager>
        <AsignacionesHistorialTabContent :idArma="idArma" />
      </v-tab-item>
      <v-tab-item key="2" eager>
        <LocsHistorialTabContent :idArma="idArma" />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import AsignacionesHistorialTabContent from '@/components/armeria/InventarioArmas/dialog-component/tab-content/AsignacionesHistorialTabContent.vue'
import LocsHistorialTabContent from '@/components/armeria/InventarioArmas/dialog-component/tab-content/LocsHistorialTabContent.vue'

export default {
  components: {
    AsignacionesHistorialTabContent,
    LocsHistorialTabContent,
  },
  props: {
    idArma: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      selectedTab: 0,
    }
  },
}
</script>
